import { AuthState } from '@okta/okta-auth-js';

import { Roles } from '../../services/backend/Roles';
import { useBaseApiClient } from '../useBaseApiClient';

export const useRoles: () => Roles<AuthState> = () => {
  return useBaseApiClient(Roles);
};
